import React from "react";
import "./banner.css";

function Banner() {
  return (
    <section id="banner" className="banner-section">
      <div className="container-fluid px-4 px-lg-5">
        <div className="row align-items-center">

          {/* TEXTO */}
          <div className="col-lg-5 banner-text">
            <h1>
              Seu TCC de Engenharia Civil com
              <span> orientação técnica e aprovação acadêmica".</span>
            </h1>

            <p className="banner-subtitle">
              Auxiliamos estudantes e 
              profissionais de Engenharia Civil a estruturarem, 
              corrigirem e finalizarem seus TCCs e Artigos
            </p>

            <a
              href="#ComoFunciona"
              className="btn btn-success btn-lg banner-btn"
            >
              Como Funciona
            </a>
          </div>

          {/* IMAGEM */}
          <div className="col-lg-7 banner-image">
            <img
              src="/Images/banner-academico.png"
              alt="Correção e orientação acadêmica"
            />
          </div>

        </div>
      </div>
    </section>
  );
}

export default Banner;
